import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { CustomerToUpdatePlansService } from './crud-service';
import { CustomerToUpdatePlansReasonDialogModule } from './customer-to-update-plans-reason-dialog/customer-to-update-plans-reason-dialog.module';
import { CustomerToUpdatePlansComponent } from './customer-to-update-plans.component';



@NgModule({
  declarations: [
    CustomerToUpdatePlansComponent
  ],
  imports: [
    CommonModule,
    TableResponsiveModule,
    AngularMaterialModule,
    FlexLayoutModule,
    CustomerToUpdatePlansReasonDialogModule
  ],
  providers: [CustomerToUpdatePlansService]
})
export class CustomerToUpdatePlansModule { }
